module.exports = __webpack_public_path__ + "static/media/22.d6968136.png";